<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  preset: {
    type: Object,
    required: true,
  },
  isCreating: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['confirm', 'back']);

const { t } = useI18n();

const scenarios = computed(() => props.preset.scenarios || []);
const guardrails = computed(() => props.preset.assistant?.guardrails || []);
const guidelines = computed(
  () => props.preset.assistant?.response_guidelines || []
);
const suggestedTools = computed(() => props.preset.suggested_tools || []);
</script>

<template>
  <div class="flex flex-col gap-5">
    <div class="flex flex-col gap-1">
      <span class="text-sm font-semibold text-n-slate-12">
        {{ preset.assistant.name }}
      </span>
      <span class="text-xs text-n-slate-11">
        {{ preset.assistant.description }}
      </span>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-xs font-medium uppercase tracking-wide text-n-slate-10">
        {{
          t('CAPTAIN.ASSISTANTS.PRESET.SCENARIOS_TITLE', {
            count: scenarios.length,
          })
        }}
      </span>
      <div class="flex flex-col gap-2">
        <div
          v-for="scenario in scenarios"
          :key="scenario.title"
          class="flex flex-col gap-0.5 p-3 rounded-lg border border-n-weak bg-n-alpha-1"
        >
          <span class="text-sm font-medium text-n-slate-12">
            {{ scenario.title }}
          </span>
          <span class="text-xs text-n-slate-11">
            {{ scenario.description }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap gap-x-6 gap-y-1 text-xs text-n-slate-11">
      <span>
        {{
          t('CAPTAIN.ASSISTANTS.PRESET.GUIDELINES_COUNT', {
            count: guidelines.length,
          })
        }}
      </span>
      <span>
        {{
          t('CAPTAIN.ASSISTANTS.PRESET.GUARDRAILS_COUNT', {
            count: guardrails.length,
          })
        }}
      </span>
      <span v-if="suggestedTools.length">
        {{
          t('CAPTAIN.ASSISTANTS.PRESET.TOOLS_COUNT', {
            count: suggestedTools.length,
          })
        }}
      </span>
    </div>

    <div class="flex items-center justify-between gap-3 pt-2">
      <Button
        type="button"
        variant="faded"
        color="slate"
        :label="t('CAPTAIN.ASSISTANTS.PRESET.BACK')"
        :disabled="isCreating"
        @click="emit('back')"
      />
      <Button
        type="button"
        color="blue"
        :label="t('CAPTAIN.ASSISTANTS.PRESET.CONFIRM')"
        :is-loading="isCreating"
        :disabled="isCreating"
        @click="emit('confirm')"
      />
    </div>
  </div>
</template>
